import React from "react";

import { NavLink } from "react-router-dom";

import { ReactSVG } from 'react-svg'





import "./index.scss";


type ButtonComponentProps = {
    text: string;
    href?: string;
    callback?: () => void;
    size?: "m" | "l";
    type?: "primary" | "secondary" | "flat" | "cta";
    subtype?: "default" | "neutral";
    title?: string;
    bordered?: boolean;
    buttonDisabled?: boolean;
    iconLeft?: string;
    iconRight?: string;
};


export const ButtonComponent:React.FC<ButtonComponentProps> = ({
    text, title, href, callback,
    size = "m", type = "primary", subtype = "default",
    buttonDisabled, bordered,
    iconLeft, iconRight
}) => {

    const cssClasses = `button-component size-${size} ${type} ${subtype}` + (bordered ? ' bordered' : '');

    return (
        href ?
            <NavLink to={href} title={title ?? text} className={cssClasses}>
                {iconLeft && <ReactSVG src={iconLeft} wrapper={"span"} className={'button-component__icon-left'} />}
                {text && <span>{text}</span>}
                {iconRight && <ReactSVG src={iconRight} wrapper={"span"} className={'button-component__icon-right'} />}
            </NavLink>
        :
            <button className={cssClasses} onClick={callback} disabled={buttonDisabled}>
                {iconLeft && <ReactSVG src={iconLeft} wrapper={"span"} className={'button-component__icon-left'} />}
                {text && <span>{text}</span>}
                {iconRight && <ReactSVG src={iconRight} wrapper={"span"} className={'button-component__icon-right'} />}
            </button>
    );

};


export default ButtonComponent;
